PLAYER p1 20 You
PLAYER p2 20 Practice partner
ACTIVE p1
p1 battlefield Plains
p1 battlefield Isamaru, Hound of Konda
p1 hand Isamaru, Hound of Konda
p1 library Forest | copies=20
p2 library Forest | copies=20
